import firebase from '../config/firebase';

const db = firebase.firestore();

const perfilService = {

    async savePerfil(perfilData) {
        try {
            const docRef = await db.collection('perfil').add(perfilData);
            return { id: docRef.id, ...perfilData };
        }
        catch (error) {
            console.error("Error adding document: ", error);
            throw error;
        }
    },

    async getPerfis() {
        try {
            const snapshot = await db.collection('perfil').get();
            const perfis = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            return perfis;
        }
        catch (error) {
            console.error("Error getting documents: ", error);
            throw error;
        }
    },

    async deletePerfil(perfilId) {
        try {
            await db.collection('perfil').doc(perfilId).delete();
        }
        catch (error) {
            console.error("Error deleting document: ", error);
            throw error;
        }
    },

    async updatePerfil(perfilId, perfilData) {
        try {
            await db.collection('perfil').doc(perfilId).update(perfilData);
        }
        catch (error) {
            console.error("Error updating document: ", error);
            throw error;
        }
    },
}

export default perfilService;